import React, { Fragment } from 'react';
import T from 'prop-types';
import { mapValues } from 'lodash-es';

import SmartChart from '../../../../../../components/Chart/SmartChart';
import ChartLegend from './ChartLegend';

const colors = ['#348BE3', '#ED5588', '#35ABB2', '#A55DC7', '#F4CD86'];

const RanksChangeChart = ({ series, selectedApps }) => {
  const legendData = selectedApps.map((app, index) => ({
    id: app.ref_no,
    name: app.name,
    icon_url: app.icon_url,
    color: colors[index],
  }));

  const metaSeriesData = mapValues(series, (_, key) => {
    const legendItem = legendData.find(({ id }) => `${id}` === key) || {};
    return { color: legendItem.color };
  });

  const chartConfig = {
    chart: {
      type: 'column',
      height: 162,
      backgroundColor: 'transparent',
      spacingBottom: 6,
      spacingLeft: 0,
    },
    title: {
      text: null,
    },
    tooltip: {
      enabled: false,
    },
    legend: {
      enabled: false,
    },
    plotOptions: {
      series: {
        minPointLength: 2,
      },
    },
    xAxis: {
      crosshair: false,
      labels: {
        format: '{value:%m/%d}',
        style: {
          color: '#848EA1',
          fontSize: '12px',
        },
      },
      lineWidth: 0,
      tickLength: 0,
      type: 'datetime',
    },
    yAxis: {
      gridLineWidth: 1,
      gridLineColor: '#EDF0F5',
      labels: {
        format: '{value}%',
        style: {
          color: '#848EA1',
          fontSize: '12px',
        },
      },
      maxPadding: 0.05,
      title: {
        text: null,
      },
    },
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 280,
          },
          chartOptions: {
            chart: {
              height: 200,
            },
          },
        },
      ],
    },
  };

  return (
    <Fragment>
      <SmartChart config={chartConfig} series={series} metaSeriesData={metaSeriesData} />
      <ChartLegend selectedApps={legendData} />
    </Fragment>
  );
};

RanksChangeChart.propTypes = {
  series: T.object.isRequired,
  selectedApps: T.array.isRequired,
};

export default RanksChangeChart;
